import { createSlice } from '@reduxjs/toolkit'

const currentDate = new Date().getTime() + 24*60*60*1000;
const lastMonthDate = currentDate - 6*30*24*60*60*1000
export const transactionSlice = createSlice({
    name: 'transactions',
    initialState: {
        transactions: [],
        filter: {
            driver: false,
            vehicle:false,
            date_from: lastMonthDate,
            date_to: currentDate,
            party: false,
        },
        reverse: false,
        isLoading: false,
        reload: false
    },
    reducers: {
        getTransactionsFetch: (state) => {
            state.isLoading = true;
        },
        getTransactionsSuccess: (state, action) => {
            state.isLoading = false
            state.transactions = action.payload
            state.reload = false

        },
        getTransactionsFail: (state) => {
            state.isLoading = false
        },
        
        filterResult: (state,action)=>{
            state.filter = action.payload
            state.reload = true

        },
       
       
        

    }
})

export const selectTransactions = (state) => state.transactions.transactions
export const selectFilter = (state) => state.transactions.filter
export const selectTransactionsIsLoading = (state) => state.transactions.isLoading

export const { getTransactionsFetch, getTransactionsSuccess, getTransactionsFail, increaseLimit, reverseList,filterResult } = transactionSlice.actions;
export default transactionSlice.reducer